import React from 'react'
import { useTranslation } from 'react-i18next'
import CategorySkeleton from './CategorySkeleton'

/**
 * The Third Party Hints section before there is anything to show in it.
 *
 * It loads through the same CategorySkeleton the other sections use, so it gets their heading and
 * their one-line placeholder, and no expander — there is nothing to collapse yet, and a control
 * that responds while the section is still loading is a trap.
 *
 * It lives apart from MyHeritageMatchesSection so that ResearchHelpContentSkeleton can render it
 * without pulling in the partner hooks, and so the two places that show this state — the page
 * skeleton, before the focus person has resolved, and the section itself, while the partner
 * request is out — cannot drift apart.
 */
export default function MyHeritageMatchesSectionSkeleton(): JSX.Element {
  const [t] = useTranslation()

  return <CategorySkeleton title={t('tree-person.third-party-hints.label')} />
}
